import TreeData from './TreeData';
export default TreeData;
